// CompanyTitle
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAboutUs } from './../actions/components/aboutUs';

const CompanyTitle = (props) => {
    const { show } = props;
    const aboutUs = useSelector((state) => state.aboutUs.aboutUs);
    const nameCompany = aboutUs.map((obj) => obj.nameCompany);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAboutUs());
    }, [dispatch]);

    const className = show ? "headerNav__logo active" : "headerNav__logo";

    if (props.button) {
        return (
            <div
                onClick={props.onClick}
                className={className}
            >
                <h2>{nameCompany}</h2>
            </div>
        );
    }

    return (
        <a
            href="/"
            className={className}
        >
            <h2>{nameCompany}</h2>
        </a>
    );
};

export default CompanyTitle;